import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path d="M2,4 L2,3 L4,3 L4,4 L2,4 Z M6,4 L6,3 L14,3 L14,4 L6,4 Z M6,7 L6,6 L14,6 L14,7 L6,7 Z M6,10 L6,9 L14,9 L14,10 L6,10 Z M2,7 L2,6 L4,6 L4,7 L2,7 Z M2,10 L2,9 L4,9 L4,10 L2,10 Z M6,13 L6,12 L14,12 L14,13 L6,13 Z M2,13 L2,12 L4,12 L4,13 L2,13 Z"/>
  </svg>
);
